import React, { Component } from 'react';
import Actions from './actions';
import classNames from 'classnames';

export default class Screens extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenObj: {},
      actionsArr: [],
      rolePermissionsArr: [],
    };
    this.renderActions = this.renderActions.bind(this);
    this.onScreenClick = this.onScreenClick.bind(this);
    this.renderPermissions = this.renderPermissions.bind(this);
  }

  componentWillMount() {
    this.setState({
      screenObj: this.props.screenPermissionObj,
      actionsArr: this.props.actionPermissions,
      rolePermissionsArr: this.props.rolePermissionsArr,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      screenObj: nextProps.screenPermissionObj,
      actionsArr: nextProps.actionPermissions,
      rolePermissionsArr: nextProps.rolePermissionsArr,
    });
  }

  handleExpandScreenRow = (rowid) => {
    let display = this.refs['actionClass' + rowid].style.display;
    if (display === 'none') {
      this.refs['actionClass' + rowid].style.display = 'table';
      this.refs['screensClass' + rowid].className = 'fa fa-minus-square';
    } else {
      this.refs['actionClass' + rowid].style.display = 'none';
      this.refs['screensClass' + rowid].className = 'fa fa-plus-square';
    }
  };

  onScreenClick(e) {
    e.preventDefault();
    let screenCheckedValue = this.state.screenObj.permission ? false : true;

    // update Role permissions - for screen and its actions
    this.renderPermissions(this.state.screenObj, screenCheckedValue);
  }

  renderPermissions(screenObj, screenCheckedValue) {

    // set permission true for all actions
    let actionsArr = this.state.actionsArr;
    actionsArr.map((obj) => {
      if (obj.screenId === screenObj.screenId) {
        obj.permission = screenCheckedValue;
      }
      return obj;
    });

    let screenPermissionsArr = this.state.rolePermissionsArr.data.screenPermissions;
    let parentModulePermissionFlag = false;
    let count = 0;
    let moduleIdCount = 0;
    screenPermissionsArr.map((obj) => {
      if (obj.moduleId === screenObj.moduleId) {
        moduleIdCount = moduleIdCount + 1;
        if (obj.screenId === screenObj.screenId) {
          obj.permission = screenCheckedValue;
        }
        if (obj.permission === true) {
          count = count + 1;
          parentModulePermissionFlag = true;
        }
        if (obj.permission === false) {
          count = count - 1;
        }
      }
      return obj;
    });

    screenObj['permission'] = screenCheckedValue;

    this.setState({
      screenObj: screenObj,
      actionsArr: actionsArr,
      rolePermissionsArr: this.state.rolePermissionsArr,
    });
    this.props.getFinalData(this.state.rolePermissionsArr, parentModulePermissionFlag);
  }

  renderActions() {
    let actionPermissions = this.state.actionsArr.filter((obj) => obj.screenId === this.state.screenObj.screenId);
    return actionPermissions.map((obj, index) => {
      return (
        <Actions
          key={index}
          actionPermissionObj={obj}
          rolePermissionsArr={this.state.rolePermissionsArr}
          getFinalData={this.storePermissions.bind(this)}
        />
      );
    });
  }

  // get final data from screen
  storePermissions(permissionData, screenPermissionFlag) {
    let screenObj = this.state.screenObj;
    screenObj['permission'] = screenPermissionFlag ? true : screenObj['permission'];
    
    this.setState({ screenObj: screenObj });
    this.props.getFinalData(permissionData, screenPermissionFlag);
  }

  render() {
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    // To show module toggle icon
    let checkScreen = this.state.actionsArr.find(o => (o.screenId === this.state.screenObj.screenId));
    return (
      <table className="tablefullwidth" key={this.state.screenObj.screenKey}>
        <tbody>
          <tr>
            <td width="50%">
              {checkScreen ? 
              <button onClick={(e) => this.handleExpandScreenRow(this.state.screenObj.screenId)} type="button" className="greyaddremove mr-15">
                <i ref={'screensClass' + this.state.screenObj.screenId} className="fa fa-plus-square" aria-hidden="true"></i>
              </button>
              : ''}
              {this.state.screenObj.screenName}
            </td>
            <td width="50%">
              <button
                type="button"
                name={'SCREEN_' + this.state.screenObj.screenId}
                className="addnum"
                title="Screen permissions"
                onClick={(e) => this.onScreenClick(e)}
                value={this.state.screenObj.permission}>
                <i className={`${this.state.screenObj.permission ? 'fa fa-check-square greenfont' : 'fa fa-minus-square redfont' }`} aria-hidden="true"></i>
              </button>
            </td>
          </tr>
          <tr className="nohover">
            <td colSpan="2">
              <table className={tableClass2} ref={'actionClass' + this.state.screenObj.screenId} style={{ 'display': 'none' }}>
                <tbody>
                  {this.renderActions()}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Masters/components/role-permission/containers/screens.js